<div class="modal-content">
  <div class="modal-body p-0">
    <mat-icon class="close-icon" mat-dialog-close>close</mat-icon>
    <mat-tab-group class="row mx-0" [(selectedIndex)]="tabNumber">
      <mat-tab label="Editar Perfil">
        <div class="row mx-0 h-100 pt-3">
          <div class="col-md-12 ps-0">
            <div class="h-100">
              <div class="avatar">
                <img class="image" *ngIf="image && image !== ''" src={{image}} alt="avatar"/>
                <label *ngIf="!image || image === ''" class="image" for="file-upload">
                  <mat-icon>add_circle_outline</mat-icon>
                </label>
                <label *ngIf="image && image !== ''" class="image edit-image" for="file-upload">
                  <mat-icon>edit</mat-icon>
                </label>
                <input id="file-upload" type="file" (input)="saveImage($event)" accept="image/png, image/jpeg"/>
              </div>
              <form novalidate [formGroup]="profileForm" #cform="ngForm" (ngSubmit)="save()">
                <div>
                  <mat-form-field class="full-width-input" appearance="outline">
                    <mat-label class="text-field">Nombre</mat-label>
                    <input matInput formControlName="name" type="text" name="name" required autocomplete="off">
                    <mat-error *ngIf="formErrors.name">{{formErrors.name}}</mat-error>
                  </mat-form-field>
                  <mat-form-field class="full-width-input" appearance="outline">
                    <mat-label class="text-field">Correo Electrónico</mat-label>
                    <input matInput formControlName="email" type="email" name="email" email autocomplete="off" readonly>
                    <mat-error *ngIf="formErrors.email">{{formErrors.email}}</mat-error>
                  </mat-form-field>
                  <mat-form-field class="full-width-input" appearance="outline">
                    <mat-label class="text-field">Teléfono</mat-label>
                    <input matInput formControlName="phone" name="phone"
                           type="text" autocomplete="off"
                           pattern="^(\+591)?[6-7]([0-9]{7,14})$">
                    <mat-error *ngIf="formErrors.phone">{{formErrors.phone}}</mat-error>
                  </mat-form-field>
                </div>
                <div class="text-center">
                  <div class="form-group pt-2">
                    <button mat-raised-button
                            class="btn btn-primary"
                            type="submit"
                            [disabled]="profileForm.invalid">
                      Editar
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Cambiar Contraseña">
        <app-change-password></app-change-password>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
<ngx-loading-x [show]="isLoading"></ngx-loading-x>